/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.querySelectorAll('template[data-lazy-popover]').forEach(function(tpl) {
	var container = tpl.closest('[id]');
	if (!container) return;
	document.querySelectorAll(`[aria-controls="${container.id}"]`).forEach(function(btn) {
		btn.addEventListener('click', () => tpl.replaceWith(tpl.content), { once: true });
	});
});

const forceModalOpen = function(id) {
	if (!document.getElementById(id)) return;
	document.querySelectorAll('.Modal[aria-hidden=false] [data-action=close-modal]').forEach(el => el.click());
	setTimeout(function() {
		const button = document.createElement('button');
		button.dataset.action = 'open-modal';
		button.classList.add('u-visually-hidden');
		button.setAttribute('aria-controls', id);

		document.body.append(button);
		button.click();
		button.remove();
	}, 10);
};


(function() {
	var query_string = new URLSearchParams(window.location.search);
	var cookie_settings = { secure: true, sameSite: 'none' };
	const delegate = new domDelegate.Delegate(document.body);
	const prefersReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
	
	// Geolocation features
	var zone = document.documentElement.dataset.zone;
	var country = Shopify.country || document.documentElement.dataset.country;
	var language = Shopify.locale || document.documentElement.lang;

	// countries.js doesn't exist on theme preview, so set a default.
	window.Countries = window.Countries || { 'United Kingdom': { code: 'GB', zip_required: 'true' }};

	const getCountryName = function(code) {
		let country_name = false;
		$.each(Countries, function(name, data) {
			if (data.code == code.toUpperCase()) {
				country_name = name;
				return false;
			}
		});
		return country_name;
	}

	const getCountryData = function(country) {
		if (country && country.toUpperCase().match(/^[A-Z]{2}$/)) {
			country = getCountryName(country);
		}
		return Countries[country] || false;
	}

	/* Localization menus */
	$('body').on('click', '.Drawer [data-action=open-modal], .Header__LocalizationForm [aria-haspopup=true], #international-welcome-modal [data-action=open-modal]', function() {
		// Close draw if necessary
		$('.Drawer__Close', $(this).closest('.Drawer')).first().trigger('click');

		// Scroll to current selected item
		var controls = $(this).attr('aria-controls');
		if (controls) {
			$(`#${controls} [data-scrollable]`).each(function() {
				if ($(this).has('.is-selected').length) {
					$(this).scrollTop($('.is-selected', this).offset().top - ($(this).height() / 2));
				}
			});
		}
	});


	// Product card colour swatches
	const colourSwatchProductCards = {};
	const colourSwatchPendingFetches = new Set();

	const fetchColourSwatchProductCards = handles => {
		handles = [...handles]; // convert Set or Array to Array
		if (handles.length == 0) return;

		handles.forEach(handle => colourSwatchPendingFetches.add(handle));
		const handlesToFetch = handles.slice(0, 20);
		
		const url = `${Shopify.routes.root}?section_id=dynamic-search&cache=false&type=${Date.now()}_${Math.random()}&products=${handlesToFetch.join(',')}`;

		return fetch(url).then(response => response.text()).then(response => {
			const newPage = new DOMParser().parseFromString(response, 'text/html');
			newPage.querySelectorAll('.ProductItem').forEach(function(item) {
				colourSwatchProductCards[item.dataset.productHandle] = item.outerHTML;
			});
		}).finally(() => {
			handlesToFetch.forEach(handle => colourSwatchPendingFetches.delete(handle));
			return fetchColourSwatchProductCards(handles.slice(20));
		});
	}

	const getNewColourSwatchHandles = context => {
		context = context || document;
		return new Set([...context.querySelectorAll('.ProductItem[data-product-handle]:has(.ColourSwatchList__Item), .ColourSwatchList__Item[data-product-handle]')]
			.map(item => item.dataset.productHandle)
			.filter(item => item != null && !colourSwatchProductCards[item] && !colourSwatchPendingFetches.has(item))
		);
	}

	const swapColourSwatchProductCard = (oldProductElement, newProductHandle, onFail) => {
		const newProductHTML = colourSwatchProductCards[newProductHandle];
		if (!newProductHTML) {
			if (onFail) onFail();
			return false;
		}

		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = newProductHTML;
		const newProductElement = tempDiv.firstElementChild.cloneNode(true);
		oldProductElement.replaceWith(newProductElement);
		document.dispatchEvent(new CustomEvent('product_list_loaded', { detail: newProductElement.parentNode })); 
		return true;
	}

	delegate.on('click', '.ProductItem .ColourSwatchList__Item', event => {
		const swatch = event.target.matches('.ColourSwatchList__Item') ? event.target : event.target.closest('.ColourSwatchList__Item');
		event.preventDefault();

		// Prevent event bubbling if swatch is inside the search container
		if (event.target.closest('.Search')) event.stopPropagation();
		
		const handleFailure = () => document.location.assign(swatch.href);

		const oldProductElement = swatch.closest('.ProductItem');
		const newProductHandle = swatch.dataset.productHandle;

		const swapCard = (i = 0) => {
			if (!newProductHandle || !oldProductElement || i >= 30) {
				handleFailure();
				return;
			}

			// While we're waiting, hide the current product card so it shows the loading animation
			const image = oldProductElement.querySelector('.Image__Loader')?.previousElementSibling;
			if (image && image.matches('.ProductItem__Image')) {
				image.classList.add('Image--lazyLoading');
				image.hidden = true;
			}
			
			if (colourSwatchProductCards[newProductHandle]) {
				swapColourSwatchProductCard(oldProductElement, newProductHandle, handleFailure);
			} else {
				if (!colourSwatchPendingFetches.has(newProductHandle)) {
					fetchColourSwatchProductCards(new Set([newProductHandle]));
				}
	
				if (colourSwatchPendingFetches.has(newProductHandle)) {
					// Check every 100ms for 3s otherwise handleFailure
					setTimeout(() => swapCard(++i), 100);
				}
			}
		};

		swapCard();
	});
	
	const initColourSwatches = context => {
		var handles = new Set();
		if (context instanceof jQuery) {
			context.each(function() {
				getNewColourSwatchHandles(this)?.forEach(handle => handles.add(handle));
			});
		} else {
			handles = getNewColourSwatchHandles(context);
		}
		fetchColourSwatchProductCards(handles);
	}
	$(document).on('product_list_loaded', function(event, children) {
		if (!children) children = event.detail;
		initColourSwatches($(children));
	});
	initColourSwatches();

	// Shopify-account web component
	document.querySelectorAll('.Account__MenuTrigger').forEach(function(trigger) {
		trigger.addEventListener('click', function(e) {
			if (e.target.closest('shopify-account')) return;
			var account = trigger.closest(':has(> shopify-account)')?.querySelector('shopify-account');
			var btn = account?.shadowRoot?.querySelector('button');
			if (btn) {
				btn.click();
			} else if (trigger.dataset.fallbackHref) {
				window.location.assign(trigger.dataset.fallbackHref);
			}
		});
	});

	// My Account remember name
	if (Cookies.get('account_first_name')) {
		document.querySelectorAll('[data-welcome-back-template]').forEach(el => {
			const tpl = el.dataset.welcomeBackTemplate;
			if (tpl) el.textContent = tpl.replace('[NAME]', Cookies.get('account_first_name'));
		});
	}

	// Yotpo loyalty points in header
	let loyaltyFetchPromise;
	document.querySelectorAll('button.LoyaltyPoints').forEach(button => {
		const customerId = button.dataset.loyaltyCustomer;
		const signature = button.dataset.loyaltySignature;
		const shop = Shopify.shop;
		const count = button.querySelector('.LoyaltyPoints__Count');
		let points;

		// Show the earned balance minus anything reserved against the cart, so the count matches the drawer's available balance.
		const updateCount = value => {
			if (count) {
				count.textContent = Math.max(0, value).toLocaleString();
			}
		};

		// One shared request for both buttons, points balance is retrieved from cache headers without hitting the endpoint directly
		if (!loyaltyFetchPromise) {
			loyaltyFetchPromise = fetch(`https://loyalty.disturbia.app/customer/${customerId}`, {
				headers: {
					"Accept": "application/json",
					"X-Shop-Domain": shop,
					"X-Customer-Signature": signature
				},
				mode: "cors"
			}).then(response => response.ok ? response.json() : null).then(result => result?.points_balance).catch(() => undefined);
		}

		loyaltyFetchPromise.then(newPoints => {
			if (!Number.isFinite(newPoints)) {
				button.remove();
				return;
			}
			button.querySelector('.LoyaltyPoints__Count').classList.remove('shimmer');
			button.removeAttribute('aria-busy');
			button.removeAttribute('aria-label');
			button.removeAttribute('tabindex');
			button.addEventListener('click', () => {
				document.dispatchEvent(new CustomEvent('yotpo-loyalty-spotlight-open-drawer'));
			});
			updateCount(newPoints);
			points = newPoints;
		});

		// Ensure header/sidebar points are updated when X points are redeemed and a voucher is added to cart
		document.addEventListener('yotpo-loyalty-spotlight-discount-changed', event => {
			const discounts = event.detail && event.detail.appliedDiscounts || [];
			const reservedPoints = discounts.filter(discount => discount.type === 'redemption').reduce((total, discount) => total + discount.amount, 0);
			if (Number.isFinite(points)) {
				updateCount(points - reservedPoints);
			}
		});
	});

	/* Country popup filter */
	document.querySelectorAll('#header-currency-popover-0, #header-currency-popover-1, #currency-modal').forEach(countrySelector => {

		// create container
		const container = document.createElement('div');
		container.classList.add('Popover__Filter');

		// create search icon
		const searchIcon = document.createElement('img');
		searchIcon.src = 'https://assets.disturbia.co.uk/assets/fa/svgs/solid/search.svg';
		searchIcon.classList.add('Popover__FilterSearchIcon');

		// create search input
		const search = document.createElement('input');
		search.type = 'text';
		search.placeholder = countrySelector.dataset.filterPlaceholder;
		search.autocomplete = 'off';
		search.classList.add('Form__Input', 'Popover__FilterInput'); 

		// create clear button
		const clearButton = document.createElement('button');
		clearButton.type = 'button';
		clearButton.textContent = '✖';
		clearButton.classList.add("Popover__FilterClearIcon");

		container.appendChild(searchIcon);
		container.appendChild(search);
		container.appendChild(clearButton);

		// Add filter form to country selector
		if (countrySelector.matches('.Modal')) {
			countrySelector.querySelector('.Modal__Header').append(container);
		} else {
			countrySelector.prepend(container);
		}

		const getValues = () => {
			return countrySelector.querySelectorAll('.Popover__Value');
		}

		const getFirstVisible = () => {
			return countrySelector.querySelector('.Popover__Value:not([hidden])');
		}

		clearButton.addEventListener('click', () => {
			search.value = '';
			getValues().forEach(country => {country.hidden = false});
		});

		search.addEventListener('input', event => {
			const inputValue = search.value.toLowerCase();
			getValues().forEach(country => {
				const currentCountry = country.textContent.toLowerCase();
				const currentCountryCode = (country.matches('[value]') ? country.value : country.dataset.country).toLowerCase();
				country.hidden = !(currentCountry.startsWith(inputValue) || currentCountryCode == inputValue || (inputValue == 'uk' && currentCountryCode == 'gb'));
			});
		});
		search.addEventListener('keydown', event => { 
			switch (event.key) {
				case 'Enter':
				case 'ArrowDown':
				case 'Tab':
					const item = getFirstVisible();
					if (item) item.focus();
					event.preventDefault();
					break;
			}
		});
	});

	$('.Modal [data-action=open-modal]').on('click', function() {
		forceModalOpen($(this).attr('aria-controls'));
	});
	


	/* Tracking Consent functionality */
	
	const startTracking = function() {
		// This should only be run if the user consents to tracking
		document.dispatchEvent(new Event('trackingLoaded'));
		$('span.allow_marketing_cookies_checkbox :checkbox').prop('checked', true);
		Cookies.set('allow_marketing_tracking', '1', cookie_settings);
	}

	const stopTracking = function() {
		Cookies.remove('allow_marketing_tracking');
	}

	Shopify.loadFeatures([{
		name: 'consent-tracking-api', 
		version: '0.1',
		onLoad: function() {
			if (typeof Shopify.customerPrivacy === 'undefined') return;
			if (Shopify.customerPrivacy.userCanBeTracked()) { 
				startTracking();
			} else {
				stopTracking();
			}

			const cookieBanner = document.getElementById('cookie-banner');
			if (cookieBanner) {
				if (Shopify.customerPrivacy.shouldShowGDPRBanner() && !Shopify.designMode) {
					cookieBanner.hidden = false;
				}

				const redisplayModal = function() {
					// If a modal was already open, make sure it doesn't close when banner is closed
					const existing_modal = document.querySelector('.Modal[aria-hidden=false]');
					if (existing_modal) {
						setTimeout(function() {forceModalOpen(existing_modal.id)}, 100);
					}
				}

				const accept = cookieBanner.querySelectorAll('.Button--primary[data-action=close-modal]');
				accept.forEach(element => {
					element.addEventListener('click', function(e) {
						Shopify.customerPrivacy.setTrackingConsent(true, function() {});
						redisplayModal();
					});
				});

				const reject = cookieBanner.querySelectorAll('.Button--secondary[data-action=close-modal]');
				reject.forEach(element => {
					element.addEventListener('click', function(e) {
						Shopify.customerPrivacy.setTrackingConsent(false, function() {});
						redisplayModal();
					});
				});

				const close = cookieBanner.querySelectorAll('[data-action=close-modal]');
				close.forEach(element => {
					element.addEventListener('click', function() {
						cookieBanner.hidden = true;
					});
				});

				const settings = cookieBanner.querySelectorAll('[data-action=show-settings]');
				settings.forEach(element => {
					element.addEventListener('click', function() {
						for (let el of cookieBanner.children) {
							el.hidden = !el.classList.contains('CookieBanner__Settings')
						}
					});
				});
			}
		}
	}]);

	document.addEventListener('trackingConsentAccepted', startTracking);

	

	$('span.allow_marketing_cookies_checkbox').each(function() {
		var input = $('<input type="checkbox"/>');
		input.prop('checked', Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.userCanBeTracked());
		$(this).empty().append(input);
		input.on('change', function() {
			if (Shopify && Shopify.customerPrivacy) {
				Shopify.customerPrivacy.setTrackingConsent(input.prop('checked'), function() {});
				if (!input.prop('checked')) stopTracking();
			} else {
				alert('Sorry, there was an error changing your cookie preference. Please reload the page and try again.');
				return false;
			}
		});
	});

	document.addEventListener('filters:refresh', () => {
		document.querySelectorAll('.CollectionInner__Products').forEach(collection => {
			const productCount = collection.querySelector('.ProductListWrapper')?.dataset.productsCount || 0;
			collection.closest('section')?.querySelectorAll('.CollectionToolbar__ProductsCount').forEach(toolbarCounter => {
				toolbarCounter.textContent = productCount;
			});
		});
	});

	// Plus-size images
	const selectPlusSizeInCarousel = function(carousel) {
		const enable = document.body.classList.contains('features--show-plussize-images');
		const flkty = Flickity.data(carousel);
		if (!flkty) return;
		let index = 0;
		if (enable) {
			const image = carousel.querySelector('.ProductItem__ImageSlideshowItem--plussize, .Product__SlideItem--plussize');
			if (image) {
				index = Math.max(-1, Array.from(image.parentElement.children).indexOf(image));
			}
		}
		if (!matchMedia('not all and (hover: hover), not all and (pointer: fine)').matches) index++;
		flkty.select(index, false, true);
	}

	const togglePlusSize = function(enable = null) {
		if (typeof enable !== 'boolean' && enable !== null) {
			enable = !document.body.classList.contains('features--show-plussize-images');
		}

		document.body.classList.toggle('features--show-plussize-images', enable);
		document.querySelectorAll('[data-action=plussize-toggle]').forEach(element => { 
			element.classList.toggle('is-active', enable);
			element.blur();
		});
		document.querySelectorAll('[data-action=plussize-show]').forEach(element => { 
			element.classList.toggle('is-active', enable);
		});
		document.querySelectorAll('[data-action=plussize-hide]').forEach(element => { 
			element.classList.toggle('is-active', !enable);
		});
		document.querySelectorAll('.ProductItem__ImageSlideshow:has(.ProductItem__ImageSlideshowItem--plussize)').forEach(carousel => selectPlusSizeInCarousel(carousel));
		document.querySelectorAll('.Product__Slideshow:has(.Product__SlideItem--plussize)').forEach(carousel => selectPlusSizeInCarousel(carousel));
		Cookies.set('plussize_images', enable ? 1 : 0, cookie_settings);
	}

	/* A/B TEST START */
	function removePlusSizeFunctionality() {
		togglePlusSize(false);
		const prodPagePlusSizeCarousel = document.querySelector('.Product__Slideshow:has(.Product__SlideItem--plussize)');
		if (prodPagePlusSizeCarousel) {
			console.log(prodPagePlusSizeCarousel)
			document.querySelectorAll('.Product__SlideshowNavImage').forEach((el, index) => {
				if (el.matches('.Product__SlideshowNavImage--plussize, .Product__SlideshowNavImage--plussize ~ *')) {
					document.querySelector(`.Product__SlideshowMobileNav .flickity-page-dots [data-index="${index}"]`)?.remove();
				}
			});
			document.querySelectorAll('.Product__SlideshowNavImage--plussize, .Product__SlideshowNavImage--plussize ~ *').forEach(el => el.remove());
			document.querySelectorAll('.Product__SlideItem--plussize, .Product__SlideItem--plussize ~ *').forEach(el => el.remove());
			document.querySelectorAll('.Product__SlideshowNavDot--plussize, .Product__SlideshowNavDot--plussize ~ *').forEach(el => el.remove());
			Flickity.data(prodPagePlusSizeCarousel).reloadCells();
		} else {
			document.querySelectorAll('.ProductItem__ImageSlideshowItem--plussize, .ProductItem__ImageSlideshowItem--plussize ~ *').forEach(el => el.remove());
		}

		document.querySelector('.Popover__ValueGroup:has([data-action^="plussize-"])')?.remove();
	}
	let abid;
	switch (Shopify.shop) {
		case 'disturbia-uk.myshopify.com':
			abid = window.dfc('CRO-DSUK-501-PLP-PDP-PLUS-SIZE');
			break;
		case 'disturbia-eu.myshopify.com':
			abid = window.dfc('CRO-DSEU-501-PLP-PDP-PLUS-SIZE');
			break;
	}
	if (abid !== 1) removePlusSizeFunctionality();
	/* A/B TEST END */

	if (Cookies.get('plussize_images') == 1) {
		togglePlusSize(true);
	}
	document.querySelectorAll('[data-action=plussize-toggle]').forEach(element => {
		element.addEventListener('click', togglePlusSize);
	});
	document.querySelectorAll('[data-action=plussize-show]').forEach(element => {
		element.addEventListener('click', () => togglePlusSize(true));
	});
	document.querySelectorAll('[data-action=plussize-hide]').forEach(element => {
		element.addEventListener('click', () => togglePlusSize(false));
	});


	// Product Features
	const productFeaturesResizeObserver = new ResizeObserver(entries => {
		for (const entry of entries) {
			Flickity.data(entry.target)?.resize();
		}
	});
	document.querySelectorAll('.ProductFeatures [data-flickity-options]').forEach(carousel => {
		new Flickity(carousel, JSON.parse(carousel.dataset.flickityOptions || {}));
		productFeaturesResizeObserver.observe(carousel);
	});


	// Product image carousel on collection pages
	const productImageCarousel = function(context) {
		if (!context || !context.length) context = $('body');
		const carousel = $('.ProductItem__ImageSlideshow', context).flickity({
			wrapAround: true,
			pageDots: false,
			dragThreshold: 20,
			initialIndex: !window.matchMedia("(hover: hover)").matches || !window.matchMedia("(pointer: fine)").matches ? 0 : 1,
			setGallerySize: false,
		});

		$('.ProductItem__ImageSlideshow', context).each(function() {
			selectPlusSizeInCarousel(this);
		});
		
		if (!prefersReducedMotion) {
			carousel.on('cellSelect.flickity', function() {
				this.querySelectorAll('video').forEach(video => video.pause());
				this.querySelector('.Carousel__Cell.is-selected video')?.play();
			});
		}
	};

	if (!prefersReducedMotion) {
		delegate.on('mouseover', '.ProductItem__ImageWrapper', event => {
			const container = event.target.matches('.ProductItem__ImageWrapper') ? event.target : event.target.closest('.ProductItem__ImageWrapper');
			const carousel = container.querySelector('.ProductItem__ImageSlideshow');
			if (carousel) {
				carousel.querySelector('.Carousel__Cell.is-selected video')?.play();
			} else {
				container.querySelector('.ProductItem__Image--alternate video')?.play();
			}
		});

		delegate.on('mouseout', '.ProductItem__ImageWrapper', event => {
			const container = event.target.matches('.ProductItem__ImageWrapper') ? event.target : event.target.closest('.ProductItem__ImageWrapper');
			container.querySelectorAll('video').forEach(video => video.pause());
		});
	}
	
	$('.CollectionInner').on('click', '.flickity-prev-next-button', function(event) {
		event.preventDefault();
	});
	$(window).on('load', function() {
		if (matchMedia('not all and (hover: hover), not all and (pointer: fine)').matches) {
		//if (!Cookies.get('collection_product_carousel_changed')) {
			$('body:not(.features--show-plussize-images) .Grid__Cell:first-of-type .ProductItem__ImageWrapper .flickity-slider').addClass('peek-intro').each(function() {
				setTimeout(() => {
					$(this).removeClass('peek-intro').closest('.ProductItem__ImageSlideshow').flickity('select', 0, false, true);
					$('.ProductItem__ImageSlideshow').on('select.flickity', function() { Cookies.set('collection_product_carousel_changed', 1, cookie_settings); });
				}, 1500);
			});
		}
	});


	// Collection Auto-pagination
	$(document).on('product_list_loaded', function(event, children) {
		// Switch the images
		if (!children) children = event.detail;

		// Show the thumbs
		$('div.ProductItem', children).css({visibility: 'inherit'});

		// Fix the opacity (which can get stuck < 1 in the cache)
		$('div.ProductItem', $(children).closest('.ProductList')).css('opacity', 1);

		// Initialize the product image carousels
		productImageCarousel(children);
	});
	
	const collectionInfiniteScroll = function() {
		var collectionSelectorPrefix = $('body').is('.features--bespoke-search') ? 'section:not(.search-results-container) ' : '';
		$(collectionSelectorPrefix + 'div.CollectionMain div.ProductList').autoload({
			paginator: 'div.Pagination',
			nextLink: 'div.Pagination a[rel=next]',
			nextContent: 'div.CollectionMain div.ProductList',
			saveContent: 'div.CollectionMain',
			onload: children => $(document).trigger('product_list_loaded', [children]),
			loading: '<p class="autoload-loading BouncingSpinner">Loading <br> <span></span><span></span></p>',
			more: '<p class="autoload-more"><a href="#" class="Button Button--primary">Load More...</a></p>',
			sequence: [true, true, false],
			offset: 400
		});
	}
	$(document).on('filters:refresh', collectionInfiniteScroll);
	collectionInfiniteScroll();

	// Code that MUST run AFTER the infinite scroll has been initiated, otherwise it pollutes the autoload cache
	productImageCarousel();
	$(document).on('filters:refresh', productImageCarousel);


	// Announcement bar
	$('div.AnnouncementBar').each(function() {
		var bar = $(this);
		if ($('a', bar).length == 1) {
			bar.addClass('clickable');
			bar.on('click', function() {
				document.location = $('a', bar).attr('href');
			});
		}
		var wrapper = $('div.AnnouncementBar__Wrapper', bar);

		if (bar.data('display-mode') == 'marquee') {

			var marquee = wrapper;
			var close = $('button.close', bar);
			var always_scroll = bar.data('always-scroll');
			var continuous_scroll = bar.data('continuous-scroll');
			
			close.hide().on('click', function() {
				bar.slideUp(function() {
					$(document).trigger('announcement:resize');
				});
				Cookies.set('hide_marquee', Date.now(), cookie_settings);
				return false;
			});
		
			var marquee_active = false;

			var scrollBannerStart = function() {
				marquee.css({
					width: 'auto',
					visibility: 'visible'
				}).marquee('destroy');
				marquee_active = false;

				marquee.children().each(function() {
					if ($(this).data('cloned')) $(this).detach();
				});

				while (continuous_scroll && contentsWidth(true) < marquee.width()) {
					marquee.append(marquee.children().clone(true).data('cloned', true));
				}

				marquee.marquee({
					speed: parseInt(bar.data('animation-speed')),
					gap: parseInt(bar.data('animation-delay')),
					delayBeforeStart: 0,
					pauseOnHover: true,
					duplicated: continuous_scroll,
				});
				marquee_active = true;
				close.show();

				initCountdownTimers(wrapper);

				$(document).trigger('announcement:resize');
			}
		
			var scrollBannerStop = function() {
				if (marquee_active) {
					marquee.marquee('destroy');
					marquee_active = false;
					close.hide();
					$(document).trigger('announcement:resize');
					marquee.children().each(function() {
						if ($(this).data('cloned')) $(this).detach();
					});
				}
				initCountdownTimers(wrapper);
			}
		
			var contentsWidth = function(include_cloned = false) {
				var width = 0;
				var children = (marquee_active ? $('div.js-marquee', marquee) : marquee).children('.AnnouncementBar__Item');
				children.each(function() {
					if (include_cloned || !$(this).data('cloned')) width += $(this).outerWidth(true);
				});
				return width;
			}

			bar.addClass('active');
			marquee.css('width', 'auto');
			if (always_scroll || contentsWidth() >= marquee.width()) {
				marquee.css('width', 'max-content');
				$(window).on('load', scrollBannerStart);
			} else {
				marquee.css('visibility', 'visible');
			}
			
			$(window).on('resize', function() {
				if (always_scroll || contentsWidth() >= marquee.width()) {
					scrollBannerStart();
				} else {
					scrollBannerStop();
				}
			});
		} else if (bar.data('display-mode') == 'fade') {
			// Reverse elements
			$('.AnnouncementBar__Item', wrapper).each(function(i, el) { wrapper.prepend(el); });
			bar.addClass('active');

			setInterval(function() {
				var children = $('.AnnouncementBar__Item', wrapper);
				if (children.length > 1) {
					$('.AnnouncementBar__Item', wrapper).eq(-2).fadeTo(parseInt(bar.data('animation-speed')), 1);
					children.last().fadeTo(parseInt(bar.data('animation-speed')), 0, function() {
						wrapper.prepend(this);
					});
				}
			}, parseInt(bar.data('animation-speed')) + (parseInt(bar.data('animation-delay')) * 1000));
		}

		var section = bar.closest('#shopify-section-announcement, #shopify-section-announcement-bottom')[0];
		if (section) {
			var cssVar = section.id === 'shopify-section-announcement' ? '--announcement-bar-height' : '--announcement-bar-bottom-height';
			new ResizeObserver(function(entries) {
				document.documentElement.style.setProperty(cssVar, entries[0].contentRect.height);
			}).observe(section);
		}
	});

	const topAnnouncementBar = document.getElementById('shopify-section-announcement');
	const bottomAnnouncementBar = document.getElementById('shopify-section-announcement-bottom');
	if (bottomAnnouncementBar && topAnnouncementBar?.querySelector('.AnnouncementBar')) {
		let announcementObserver = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				bottomAnnouncementBar.classList.add('animate');
				bottomAnnouncementBar.classList.toggle('show', !entry.isIntersecting);
			});
		});
		announcementObserver.observe(topAnnouncementBar);
	}

	// Global-e shipping banner
	const setGlobalEFreeShippingMessage = function(message, container) {
		// Set the cart shipping message to Global-e's free shipping message if there isn't a default message
		if (message && message.length) {
			const containers = container ? [container] : document.querySelectorAll('.Cart__ShippingMessage');
			containers.forEach(container => {
				if (container.textContent.length == 0 || container.matches('.globale-shipping-message')) {
					const p = document.createElement('p');
					p.classList.add('free-delivery-message');
					p.textContent = message;
					container.replaceChildren(p);
					container.classList.add('globale-shipping-message');
				}
			});
		}
	}
	var globale_shipping_message = '';
	const globaleObserver = new MutationObserver(function (list) {
		loop: for (const mutation of list) {
			if (mutation.type === 'childList') {
				for (const node of mutation.addedNodes) {
					globale_shipping_message = $(node).text();

					// Cart free shipping message
					setGlobalEFreeShippingMessage(globale_shipping_message);

					// Promo Icons free shipping message
					$('.PromoIcons .globale-replace .PromoIcons__Message > div').empty().append(`<p>${globale_shipping_message}</p>`);

					// Add to announcement bar
					const containers = $('div.AnnouncementBar .globale-replace');
					$(node).wrapInner('<p class="AnnouncementBar__Content globale-shipping-banner"></p>');
					if (containers.length) {
						containers.empty().append($(node).contents());
					} else {
						$('div.AnnouncementBar.globale-append').each(function() {
							const container = $('.AnnouncementBar__Item').last().clone(true);
							container.empty().append($(node).contents().clone());
							if ($(this).data('display-mode') == 'fade') {
								$(this).children().prepend(container);
							} else {
								$(this).children().append(container);
							}
						});
					}
					$(document).trigger('announcement:resize');
				}
			}
		}
	});
	if (window.theme.globaleEnabled && document.getElementById('globale-banner')) globaleObserver.observe(document.getElementById('globale-banner'), { childList: true });

	// FAQ headings
	var speed = 250;
	var target = '.Faq__CollapseSections .Faq__Section';
	$('body').on('faq_open', target, function() {
		var heading = $(this);
		heading.closest('.Faq').siblings('.Faq').children('.Faq__Section').trigger('faq_close');
		heading.attr('aria-expanded', 'true');
		heading.next('.Faq__SectionWrapper').attr('aria-hidden', 'false').slideDown(speed);
	}).on('faq_close', target, function() {
		var heading = $(this);
		heading.attr('aria-expanded', 'false');
		heading.next('.Faq__SectionWrapper').attr('aria-hidden', 'true').slideUp(speed);
	}).on('blockselect', target, function() {
		$(this).trigger('faq_open');
	}).on('blockdeselect', target, function() {
		$(this).trigger('faq_close');
	}).on('click', target, function(event) {
		var heading = $(this);
		if (heading.attr('aria-expanded') == 'true') {
			heading.trigger('faq_close');
		} else {
			heading.trigger('faq_open');
		}
		return false;
	});


	// Tweak Highlighted Collections
	const highlighted_collections_count = $('.HighlightedCollection').length;
	if (highlighted_collections_count) {
		const highlightedCollectionSpacing = function() {
			$('.HighlightedCollection').each(function(index) {
				const image = $('.HighlightedCollection__ImageContainer', this);
				const content_height = $('.HighlightedCollection__ContentContainer', this).height();
				const image_height = image.height();
				const spacing = Math.max(parseInt(image.css('margin-left')), parseInt(image.css('margin-left')));
				const overlap = -parseInt($(this).css('margin-bottom'));
				const multiplier = index == 0 || index == highlighted_collections_count - 1 ? 1 : 2;
				const difference = (image_height - (multiplier * overlap)) - (content_height + (multiplier * spacing));
				if (difference < 0) {
					$(this).css({paddingTop: index == 0 ? 0 : -difference/2 + 'px', paddingBottom: -difference/2 + 'px'});
				} else {
					$(this).css({paddingTop: '0px', paddingBottom: '0px'});
				}
			});
		}
		window.addEventListener('resize', highlightedCollectionSpacing, { passive: true });
		$(window).on('load', highlightedCollectionSpacing);
		$(window).on('lazyloaded', e => { if ($(e.target).is('.HighlightedCollection__Image')) { highlightedCollectionSpacing() }})
	}

	// Extend the cart cookie
	const cartToken = Cookies.get('cart');
	if (typeof cartToken === 'string' && cartToken.length) {
		Cookies.set('cart', cartToken, { expires: 90, sameSite: 'Lax' });
	}

	if (navigator.share) {
		$(document).on('click', 'button.native-share', function() {
			navigator.share({
				title: document.title,
				url: document.querySelector('link[rel=canonical]') ? document.querySelector('link[rel=canonical]').href : document.location.href,
			});
			return false;
		});
	}

	
	// Country-related functions
	if (country) {
		
		// Shipping Guides
		const initShippingGuides = container => {
			container = container || document.body;
			const guides = container.querySelectorAll('.ShippingGuide');
			const button = container.querySelector('button[data-action=shipping-guides-show]')
			const country_guides = [];
			const zone_guides = [];
			guides.forEach(guide => {
				if(guide.dataset.countries?.toLowerCase().split(',').includes(country?.toLowerCase())) {
					country_guides.push(guide);
				}
				if(guide.dataset.zones?.toLowerCase().split(',').includes(zone?.toLowerCase())) {
					zone_guides.push(guide);
				}
			});

			if (button && (country_guides.length || zone_guides.length)) {
				guides.forEach(guide => guide.hidden = true);
				button.hidden = false;
				if (country_guides.length) {
					country_guides.forEach(guide => guide.hidden = false);
				} else if (zone_guides.length) {
					zone_guides.forEach(guide => guide.hidden = false);
				}

				button.addEventListener('click', event => {
					guides.forEach(guide => guide.hidden = false);
					button.hidden = true;
					event.preventDefault();
				});
			}
		};
		initShippingGuides();

		const fetchShippingGuides = (onError = () => {}, url = null) => {
			const container = document.createElement('div');
			url = url || window.routes.shippingGuideUrl;
			if (!url) return;

			const loading = document.createElement('div');
			loading.classList.add('BouncingSpinner');
			loading.innerHTML = '<span></span><span></span>';
			container.append(loading);
			
			fetch(url).then(response => {
				if (!response.ok) throw new Error('Bad response');
				return response.text()
			}).then(response => {
				const newPage = new DOMParser().parseFromString(response, 'text/html');
				newPage.querySelectorAll('.ShippingGuide, button[data-action=shipping-guides-show]').forEach(guide => {
					container.append(guide);
				});
				initShippingGuides(container);
			}).catch(onError).finally(() => loading.remove());

			return container;
		}

		// Dynamically load shipping guides on product page and shipping policy
		document.querySelectorAll('.ShippingGuide__Placeholder').forEach(container => {
			const new_container = fetchShippingGuides(() => container.hidden = false);
			container.before(new_container);
			container.hidden = true;
		});

		const cartObserver = new MutationObserver(function (list) {
			loop: for (const mutation of list) {
				if (mutation.type === 'childList') {
					for (const node of mutation.addedNodes) {
						if (node.matches('.Cart')) {
							// If a default free shipping message isn't provided, use the Global-e shipping banner message
							if (globale_shipping_message.length) setGlobalEFreeShippingMessage(globale_shipping_message, node.querySelector('.Cart__ShippingMessage'));
							break loop;
						}
					}
				}
			}
		});

		if (window.theme.globaleEnabled && document.querySelector('.Cart')) cartObserver.observe(document.querySelector('.Cart').parentElement, { childList: true });
	}

	// Social proof banner on the PDP — unified endpoint returns either orders or cart-adds data
	document.querySelectorAll('.Product__PopupLabel[data-handle]').forEach(el => {
		const handle = el.dataset.handle;
		if (!handle) return;
		const url = `https://sop.disturbia.co.uk/api/stats/${encodeURIComponent(handle)}`; // TODO: URL will need to be updated to official Disturiba SOP URL when go live
		fetch(url).then(response => response.text()).then(body => {
			if (!body.trim()) return;
			const data = JSON.parse(body);
			const count = parseInt(data.count);
			if (Number.isNaN(count) || count <= 0) return;
			const typeSegment = data.type === 'orders' ? 'Orders' : 'CartAdds';
			const content = window.languages[`socialProof${typeSegment}${data.window}`];
			if (!content) return;
			el.querySelector('.Product__PopupLabelText').textContent = content.replace(/##/g, count);
			setTimeout(() => { el.hidden = false; }, 1000);
			setTimeout(() => { el.hidden = true; }, 8000);
		}).catch(() => {});
	});

	
	// Featured/Promoted collection infinite scroll
	$('[data-flickity-options]').each(function() {
		const el = $(this).flickity($(this).data('flickity-options'));
		$(document).on('breakpoint:changed', function() {
			el.flickity('resize');
			el.flickity('reloadCells');
		});
	});
	$('.Carousel--infinite[data-next-link^="/"]').each(function() {
		let parent = $(this);
		let next_link = parent.data('next-link');
		let flkty = false;
		let section_id = parent.closest('[data-section-id]').data('section-id');
		let block_id = parent.closest('[data-block-id]').data('block-id');
		if ($('.flickity-slider', parent).length) {
			flkty = Flickity.data(parent.get(0));
			parent = $('.flickity-slider', parent);
		}
		let first_child = parent.children('.Carousel__Cell').first().get(0);
		let observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					if (next_link && next_link.length) {
						next_link += `&section_id=${section_id}`;
						observer.unobserve(first_child);
						if ($('.flickity-slider', parent).length) {
							flkty = Flickity.data(parent.get(0));
							parent = $('.flickity-slider', parent);
						}
						$.get(next_link).done(result => {
							next_link = $('[data-next-link]', result).data('next-link');
							let children = $(`#block-${block_id} .Carousel__Cell`, result);
							if (children.length) {
								(flkty || parent).append(children);
								first_child = children.first().get(0);
								observer.observe(first_child);
							}
						});
					}
				}
			});
		}, {root: this});
		observer.observe(first_child);
	});

	
	// Trap enter keypress on search form to allow redirection to collection
	document.querySelectorAll('.Search__SearchBar .Search__Input').forEach(element => {
		element.addEventListener('keydown', event => {
			if (event.key == 'Enter') {
				const button = element.closest('.Search')?.querySelector('.Segment__ButtonWrapper a');
				if (button) {
					button.click();
					event.preventDefault();
				}
			}
		});
	});


	// Make search results clickable
	$('.Search__Results').on('click', '.ProductItem__Wrapper', function() {
		document.location.assign($('a', this).attr('href'));
	});


	// Stock Notification buttons in collection lists
	const initBackInStockCollectionPageButtons = function(context) {
		context = context || document;
		context.querySelectorAll('.ProductItem:not(.ProductItem--available, .ProductItem--promo)').forEach(element => {
			const link = element.querySelector('a.ProductItem__ImageWrapper');
			const button = document.createElement('button');
			button.classList.add('Button', 'Button--secondary', 'Button--opaque', 'klaviyo-bis-button');
			button.append('Notify me!');
			element.querySelector('.ProductItem__Info')?.before(button);
			button.addEventListener('click', event => {
				const url = new URL(link.href);
				url.searchParams.append('notify', 'back-in-stock');
				link.href = url;
				link.click();
			});
		})
	};
	
	$(document).on('product_list_loaded', function(event, children) {
		if (!children) children = event.detail;
		if (children instanceof jQuery) {
			children.each(function() { initBackInStockCollectionPageButtons(this) });
		} else {
			initBackInStockCollectionPageButtons(children);
		}
	});
	initBackInStockCollectionPageButtons();

	if (query_string.get('notify') == 'back-in-stock') {
		const klaviyoNotificationObserver = new MutationObserver(function (list) {
			loop: for (const mutation of list) {
				if (mutation.type === 'childList') {
					for (const node of mutation.addedNodes) {
						if ($(node).is('a.klaviyo-bis-trigger')) {
							// setTimeout is to stop Safari being crashy when the node is clicked immediately
							setTimeout(()=>node.click(), 1);
							break loop;
						}
					}
				}
			}
		});
		klaviyoNotificationObserver.observe($('#klaviyo-bis-container')[0], { childList: true });
	}

	// Stock notifications in variant selectors
	delegate.on('click', '.ProductForm__Variants li.no-stock label', event => {
		const trigger = document.querySelector('a.klaviyo-bis-trigger');
		if (trigger) {
			setTimeout(() => trigger.click(), 10);
		} else {
			const link = event.target.closest('.ProductItem').querySelector('a.ProductItem__ImageWrapper');
			var url = new URL(link.href);
			url.searchParams.append('notify', 'back-in-stock');
			document.location.assign(url);
		}
	});

	// AJAX add to cart
	$('body').on('click', '[data-action="add-to-cart-noform"]', function() {
		var button = $(this);
		button.attr('disabled', 'disabled');
		$(document).trigger('theme:loading:start');
		fetch(window.routes.cartAddUrl + ".js", {
			body: JSON.stringify({
				id: button.attr('data-variant-id'),
				selling_plan: button.attr('data-selling-plan'),
			}),
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
			}
		}).then(function(response) {
			button.removeAttr('disabled');
			$(document).trigger('theme:loading:end');
			if (response.ok) {
				if ($('#sidebar-cart').length) {
					button[0].dispatchEvent(new CustomEvent('product:added', {
						bubbles: true,
						detail: {
							variant: button.attr('data-variant-id'),
							quantity: 1
						}
					}));
				} else {
					document.location.assign(window.routes.cartUrl);
				}
			} else {
				response.json().then(function(content) {
					alert(content['description']);
					document.location.assign(button.attr('href'));
				});
			}
		})
		return false;
	});

	// Cart drawer free gift variant selection
	delegate.on('change', '.FreeGift__Form select[name="id"]', e => {
		const select = e.target.closest('select');
		const btn = select?.closest('.FreeGift__Form')?.querySelector('[data-action="add-to-cart-noform"][data-variant-id]');
		if (btn && select.value) btn.dataset.variantId = select.value;
	});


	// Countdown timers
	function initCountdownTimers(container) {
		container = container || document.body;
		if ($.fn.countdown) {
			$('.CountdownTimer span.timer', container).countdown({
				onEnd: function() {
					$(this).closest('.CountdownTimer').addClass('finished');
				}
			});
		}
	}
	if (Shopify.designMode && $.fn.countdown) {
		$('body').on('shopify:section:load', () => initCountdownTimers(event.target));
	}
	initCountdownTimers();


	// Available in other store links
	document.querySelectorAll('[data-store-availability]').forEach(async container => {
		const stores = container.dataset.storeAvailability.split(',');

		const query = JSON.stringify({
			query: `query($handle: String!) { product(handle: $handle) { availableForSale } shop { primaryDomain { host } } }`,
			variables: { handle: container.dataset.productHandle },
		});

		const url = new URL(document.location);
		url.searchParams.set('country', country);

		const requests = stores.map(store => fetch(
			`https://${store}/api/2025-07/graphql.json`, 
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-Shopify-Storefront-Access-Token": window.theme?.storeTokens[store],
				},
				body: query,
			}
		));

		const responses = await Promise.allSettled(requests);
		const successfulResponses = responses.filter(response => response.status == 'fulfilled' && response.value.ok);
		const results = successfulResponses.map(response => response.value.json());
		const data = await Promise.allSettled(results);
		
		const links = data.map(result => result.value.data).filter(result => result?.product?.availableForSale).map(result => result?.shop?.primaryDomain?.host).filter(host => host.length).map(store => {
			url.hostname = store;
			return `<a href="${url}" target="_blank"><u>${window.theme?.storeNames[store]}</u></a>`
		}).join(' | ');

		if (links.length) {
			container.innerHTML = container.innerHTML.replace('[STORES]', links);
			container.hidden = false;
		}
	});


	// Mobile navigation
	document.querySelectorAll('.SidebarMenu').forEach(sidebar => {
		sidebar.querySelectorAll('[data-action]:not([data-action=close-drawer])').forEach(element => element.addEventListener('click', event => {
			event.preventDefault();
			sidebar.querySelector('[data-action=close-drawer]')?.click();
		}));

		sidebar.querySelector('[data-action=close-drawer]')?.addEventListener('click', event => {
			setTimeout(() => sidebar.querySelectorAll('.SidebarMenu__SubMenu.active, .SidebarMenu__SubSubMenu.active').forEach(element => element.classList.remove('active')), 500);
			document.querySelector(`[data-action=open-drawer][data-drawer-id=${sidebar.id}]`)?.focus();
		});

		sidebar.querySelectorAll('.SidebarMenu__Nav .SidebarMenu__Button:not([data-action])').forEach(button => button.addEventListener('click', event => {
			button.closest('.SidebarMenu__Nav')?.querySelectorAll('.SidebarMenu__SubMenu, .SidebarMenu__SubSubMenu').forEach(menu => menu.classList.remove('active'));
			button.closest('li')?.querySelector('.SidebarMenu__SubMenu, .SidebarMenu__SubSubMenu')?.classList.add('active');
		}));

		sidebar.querySelectorAll('.SidebarMenu__Back').forEach(button => button.addEventListener('click', event => {
			const active = button.closest('.SidebarMenu__SubMenu.active, .SidebarMenu__SubSubMenu.active');
			active.classList.remove('active');
			if (active.matches('.SidebarMenu__SubSubMenu')) active.closest('.SidebarMenu__SubMenu')?.classList.add('active');
		}));
	});


	// Carousel for payment provider messages (incompatible with PayPal messaging)
	window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];

	const initPaymentProviderFlickity = container => {
		if (!container.matches('.flickity-enabled')) {
			const flkty = new Flickity(container, JSON.parse(container.dataset.flickityOptions || {}));
			flkty.on('cellSelect', () => flkty.reloadCells());
		}
	}

	const initPaymentProviderMessaging = container => {
		if (container.querySelectorAll(':scope > .cell').length > 1) {
			initPaymentProviderFlickity(container);
		} else {
			const paymentMessageCellObserver = new MutationObserver(list => {
				paymentMessageCellObserver.disconnect();
				initPaymentProviderMessaging(container);
			});
			[...container.children].forEach(element => paymentMessageCellObserver.observe(element, {childList: true}));
		}
	}

	document.querySelectorAll('.ProductForm .Product__PaymentProviderMessages[data-flickity-options]').forEach(initPaymentProviderMessaging);

	const cartPaymentMessageObserver = new MutationObserver(function (list) {
		loop: for (const mutation of list) {
			if (mutation.type === 'childList') {
				for (const node of mutation.addedNodes) {
					if (node.matches('.Cart')) {
						//initPaymentProviderMessaging(node);
						if (window.Klarna) Klarna.OnsiteMessaging.refresh();
						if (window.paypal) paypal.Messages.render('[data-pp-message]');
						break loop;
					}
				}
			}
		}
	});
	const cart = document.querySelector('.Cart')
	if (cart && cart.parentElement) cartPaymentMessageObserver.observe(cart.parentElement, { childList: true });


	/* Sticky checkout bar */
	const productFormAddButton = document.querySelector('.Product button.ProductForm__AddToCart');

	// Check if the button exists
	if (productFormAddButton) {
		const productForm = productFormAddButton.closest('form');

		const stickyButtonContainer = document.createElement('div');
		stickyButtonContainer.classList.add('Product__StickyContainer');

		const stickyButtonModal = document.getElementById('variant-modal');

		const stickyButton = document.createElement('button');
		stickyButton.classList.add('Button', 'Button--primary', 'Button--full');
		stickyButton.textContent = window.languages.productFormAddToCart;

		// If the modal exists, set up the button to open the modal
		if (stickyButtonModal) {
			const iconUrl = 'https://assets.disturbia.co.uk/assets/fa/svgs/solid/angle-down.svg';
			const iconImg = document.createElement('img');
			iconImg.src = iconUrl;
			iconImg.classList.add('Icon');
			stickyButton.appendChild(iconImg);
			stickyButton.dataset.action = 'open-modal';
			stickyButton.setAttribute('aria-controls', 'variant-modal'); 
			
			stickyButtonModal.querySelectorAll('button.Popover__Value').forEach(button => {
				// Add event listeners to variant buttons in the modal
				button.addEventListener('click', event => {
					stickyButtonModal.querySelector('.Modal__Close').click();
					document.querySelector(`[for=${button.dataset.option}]`).click();
					setTimeout(() => productFormAddButton.click(), 100);
				});

				// Check variant is out of stock
				const variantSelector = document.getElementById(button.dataset.option).closest('.HorizontalList__Item');
				if (variantSelector.classList.contains('no-stock')) {
					button.classList.add('no-stock');
				}

				// Check if variant has tooltip
				const toolTip = variantSelector.querySelector('[data-tooltip]');
				const newTooltip = document.createElement('span');
				if (toolTip) {
					newTooltip.classList.add('Text--subdued');
					newTooltip.classList.add('HorizontalList__Item');
					newTooltip.textContent = toolTip.dataset.tooltip;
					button.closest('.Popover__ValueList').classList.add('has-tooltips');
				}

				// Check if variant has icon
				const icon = variantSelector.querySelector('img.Icon');
				if (icon) {
					newTooltip.prepend(icon.cloneNode());
				}

				// Append tooltip/icon
				if (newTooltip.textContent.length) {
					button.append(newTooltip);
				}
			});
		} else {
			// Otherwise, set up the button to trigger the original "Add to Cart" button
			stickyButton.addEventListener('click', event => {
				productFormAddButton.click();
				event.preventDefault();
			});
		}

		stickyButtonContainer.append(stickyButton);

		const productFormWishlistButton = productForm.querySelector('.cake-wishlist-icon');
		if (productFormWishlistButton) {
			const wishlistButton = productFormWishlistButton.cloneNode(true);
			wishlistButton.querySelectorAll('.wishlist-label').forEach(label => label.hidden = true);
			stickyButtonContainer.appendChild(wishlistButton);
		}

		document.body.append(stickyButtonContainer);

		const stickyButtonObserver = new IntersectionObserver((entries) => {
			var intersecting = false;
			entries.forEach(entry => {
				if (entry.isIntersecting) intersecting = true;
			});
			stickyButtonContainer.hidden = intersecting;
		}, {
			root: null,
			threshold: 0.9,
		});

		const productFormVariants = productForm.querySelector('.ProductForm__Variants');
		stickyButtonObserver.observe(productFormVariants || productFormAddButton);
	}
	

	const customImageAnimationObserver = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				if (entry.target.complete) {
					entry.target.classList.add('Image--lazyLoaded');
				} else {
					entry.target.addEventListener('load', event => event.target.classList.add('Image--lazyLoaded'));
				}
				customImageAnimationObserver.unobserve(entry.target);
			}
		});
	}, {threshold: 0.2});
	[...document.getElementsByClassName('Image--slideCustom')].forEach(element => customImageAnimationObserver.observe(element));


	// Subtype filters
	$('.CollectionFilters').on('change', '[name="filter.p.m.filter.type"]', function() {
		// Clicking on a type deselects all subtypes (including subtypes of other types)
		$('[name="filter.p.m.filter.subtype"]', $(this).closest('ul')).prop('checked', false);
	});
	$('.CollectionFilters').on('change', '[name="filter.p.m.filter.subtype"]', function() {
		// Clicking on a subtype deselects all types, and all subtypes except under the current type
		$('[name="filter.p.m.filter.type"]', $(this).closest('ul.Linklist')).prop('checked', false);
		$('[name="filter.p.m.filter.subtype"]', $(this).closest('li:not(.Linklist__SubItem)').siblings()).prop('checked', false);
	});


	const prepareFilters = function() {
		$('.CollectionFilters button.show-all').on('click', function() {
			$(this).prev('ul').children().show();
			$(this).remove();
		});
	};
	prepareFilters();
	$(document).on('theme:loading:end', prepareFilters);
	

	// Make Cloudflare videos clickable
	$('div.cf-video[data-video-link]').click(function() {
		document.location.assign(this.dataset.videoLink);
	});

	// Make videos lazy load
	var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          video.target.play();
          observer.unobserve(video.target);
        }
      });
    });
    document.querySelectorAll(".Video--lazy video").forEach(video => lazyVideoObserver.observe(video));


	// Review count text on collection pages
	$(document).on('product_list_loaded', function() {
        // Initialize Yotpo star ratings
		if (typeof yotpoWidgetsContainer !== 'undefined') {
			if (document.readyState === "complete") {
				yotpoWidgetsContainer.initWidgets(false);
			} else {
				document.onreadystatechange = () => { if (document.readyState === "complete") yotpoWidgetsContainer.initWidgets(false); }
			}
        }
	}).on('click', '.ProductItem__Info .standalone-bottomline', function() {
		this.closest('.ProductItem__Wrapper').querySelector('a.ProductItem__ImageWrapper').click();
	});


	// Clickable table rows
	// Make a table row clickable if it contains a link with class "row-action"
	delegate.on('click', 'tr:has(.row-action)', function(event) {
		const avoid = '.row-action, a, button, input, select, textarea';

		if (!event.target.matches(avoid) && event.target.closest(avoid) === null) {
			const action = event.target.closest('tr').querySelector('.row-action');
			if (action) action.click();
		}
	});


	// Gift cards
	document.querySelectorAll('.ProductForm__GiftCardFields--is_a_gift input').forEach(checkbox => {
		checkbox.addEventListener('change', event => {
			event.target.closest('.ProductForm__GiftCardFields').querySelectorAll('.Form__Item').forEach(item => {
				item.hidden = !checkbox.checked;
			});
		});
		window.addEventListener('pageshow', event => {
			checkbox.dispatchEvent(new Event('change'));
		});
	});

	// Gift card recipient country redirect
	document.querySelectorAll('.ProductForm__GiftCardFields').forEach(giftCardForm => {
		const select = giftCardForm.querySelector('.ProductForm__GiftCardCountrySelect');
		if (!select || !window.theme?.storefrontRedirect) return;

		const { countryInThisStore, getDomainFromCountry } = window.theme.storefrontRedirect;
		const redirectDiv = giftCardForm.querySelector('.ProductForm__GiftCardRedirect');
		const tpl = redirectDiv.querySelector('template');
		tpl.replaceWith(tpl.content);

		const updateRedirect = function() {
			const countryName = select.value;
			const country = Countries[countryName]?.code;
			if (!country || countryInThisStore(country)) {
				redirectDiv.hidden = true;
				return;
			}
			const domain = getDomainFromCountry(country);
			if (!domain) {
				redirectDiv.hidden = true;
				return;
			}
			const storeName = window.theme?.storeNames?.[domain] || domain;
			const targetUrl = new URL(document.location);
			targetUrl.hostname = domain;
			targetUrl.searchParams.set('country', country);

			redirectDiv.querySelectorAll('[data-replace-with]').forEach(el => {
				switch (el.dataset.replaceWith) {
					case 'country': el.textContent = countryName; break;
					case 'store':   el.textContent = storeName; break;
					case 'url':     el.href = targetUrl.toString(); break;
				}
			});

			redirectDiv.hidden = false;
		}

		select.addEventListener('change', updateRedirect);

		// Default the dropdown to the customer's current country
		select.value = getCountryName(Shopify.country);

		// The browser restores the previous selection when navigating back and re runs against the restored value.
		window.addEventListener('pageshow', updateRedirect);
	});

	// Cart Upsell
	const initCartUpsell = upsell => {
		const productList = upsell?.querySelector('.CartUpsell__ProductList');

		productList?.setAttribute('aria-hidden', Cookies.get('cart_upsell_hidden') === '1' ? 'true' : 'false');

		requestAnimationFrame(() => {
			upsell?.classList.add('CartUpsell--ready');
		});

		if (productList && !productList.matches('.flickity-enabled') && typeof productList.dataset.flickityConfig !== 'undefined') {
			new Flickity(productList, JSON.parse(productList.dataset.flickityConfig || {}));
		}
	}

	document.querySelectorAll('.CartUpsell').forEach(initCartUpsell);

	delegate.on('click', '.CartUpsell__Toggle', event => {
		const productList = event.target.closest('.CartUpsell')?.querySelector('.CartUpsell__ProductList');
		const hidden = productList?.getAttribute('aria-hidden') === 'true';
		Cookies.set('cart_upsell_hidden', hidden ? '0' : '1', { ...cookie_settings, expires: 1 });
		productList?.setAttribute('aria-hidden', hidden ? 'false' : 'true');
	});

	new MutationObserver(list => {
		loop: for (const mutation of list) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden' && mutation.target.matches('.Cart')) {
				if (mutation.target.getAttribute('aria-hidden') === 'false') {
					const upsell = mutation.target.querySelector('.CartUpsell');
					initCartUpsell(upsell);
					break loop;
				}
			} else if (mutation.type === 'childList') {
				for (const node of mutation.addedNodes) {
					if (node.nodeType === Node.ELEMENT_NODE && node.matches('.Cart')) {
						const upsell = node.querySelector('.CartUpsell');
						initCartUpsell(upsell);
						break loop;
					}
				}
			}
		}
	}).observe(document.querySelector('.Cart')?.parentElement, {
		attributes: true,
		attributeFilter: ['aria-hidden'],
		childList: true,
		subtree: true
	});
	
	
	// Add loading class to root element while theme is in loading state
	document.addEventListener('theme:loading:start', () => {
		document.documentElement.classList.add('is-loading');
	});
	document.addEventListener('theme:loading:end', () => {
		document.documentElement.classList.remove('is-loading');
	});
	
	
	// Remove all bundle properties when any bundle item is removed
	document.addEventListener('theme:loading:end', async (event) => {
		const { cart, quantity, dataset } = event.detail || {};

		const action = dataset?.action;
		if (action !== 'remove-item' && !(action === 'update-item-quantity' && quantity === 0)) {
			return;
		}

		if (!dataset?.properties) return;

		let propsArray;

		try {
			propsArray = JSON.parse(dataset.properties);
		} catch (error) {
			console.warn('dataset.properties JSON error', dataset.properties, error);
			return;
		}

		const props = Object.fromEntries(propsArray);
		const bundleId = props._bundle_id;
		if (!bundleId) return;

		// Fetch current cart and find any items still linked to this bundle
		const bundleItems = cart.items.filter(item => item.properties?._bundle_id === bundleId);
		if (!bundleItems.length) return;

		// Update each line item *sequentially* to avoid Shopify overwrites/race condition
		for (const item of bundleItems) {
			const updatedProps = { ...item.properties };
			delete updatedProps.Bundle;
			delete updatedProps._bundle_id;
			delete updatedProps._bundle_step;
			updatedProps._removed_from_bundle = bundleId;

			try {
				const res = await fetch(`${window.routes.cartChangeUrl}.js`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						id: item.key,
						quantity: item.quantity,
						properties: updatedProps
					})
				});
				if (!res.ok) throw new Error(`cartChange failed (${res.status})`);
			} catch (error) {
				console.error(`Error updating cart item ${item.key}:`, error);
			}
		}
		
		document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
	});


	// Size guides
	const initSizeGuideTables = container => {
		container = container || document;
		container.querySelectorAll('table.SizeGuide').forEach(table => {
			const hiddenCols = new Set();
			const fixedCols = new Set();
			const optionCols = new Map();
			const options = new Set();
			const cols = new Map();
			const headers = new Map();
			const handle = table.closest('[data-size-guide]')?.dataset.sizeGuide;

			const showColumn = key => cols.get(key)?.forEach(cell => cell.hidden = false);
			const hideColumn = key => cols.get(key)?.forEach(cell => cell.hidden = true);

			table.querySelectorAll('thead th').forEach((cell, key) => {
				const opt = cell.dataset.sizeGuideOpt;
				if (typeof opt == 'undefined') {
					hiddenCols.add(key);
				} else if (opt == '#') {
					fixedCols.add(key);
				} else {
					let col = optionCols.get(opt);
					if (!col) col = optionCols.set(opt, new Set()).get(opt);
					col.add(key);
					options.add(opt);
				}

				cols.set(key, new Set([cell]));
			});

			table.querySelectorAll('tr').forEach(row => {
				row.childNodes.forEach((cell, key) => {
					let col = cols.get(key);
					if (!col) col = cols.set(key, new Set()).get(key);
					col.add(cell);
					if (cell.nodeName == 'TH' && !headers.get(key)) headers.set(key, cell.textContent);
				});
			});

			const hiddenColumnsSelector = document.createElement('select');
			hiddenCols.forEach(key => {
				const option = document.createElement('option');
				option.value = key;
				option.textContent = headers.get(key);
				hiddenColumnsSelector.append(option);
			});

			let firstHiddenColumn = hiddenCols.values().next().value;
			const hiddenColumnCookieValue = Cookies.get(`size_guide_hidden_cols_opt--${handle}`);
			hiddenCols.forEach(key => {
				if (hiddenColumnCookieValue) {
					if (key != hiddenColumnCookieValue) hideColumn(key);
				} else if (key != firstHiddenColumn) {
					hideColumn(key);
				}
				const header = [...cols.get(key)].filter(cell => cell.nodeName == 'TH')[0];
				const selectorCopy = hiddenColumnsSelector.cloneNode(true);
				header.replaceChildren(selectorCopy);
				selectorCopy.addEventListener('change', function() {
					const newKey = parseInt(this.value);
					hideColumn(key);
					showColumn(newKey);
					this.value = key;
					Cookies.set(`size_guide_hidden_cols_opt--${handle}`, newKey, cookie_settings);
				});
				selectorCopy.value = key;
			});

			const optionColumnsSelector = document.createElement('select');
			options.forEach(opt => {
				const option = document.createElement('option');
				option.value = opt;
				option.textContent = opt;
				optionColumnsSelector.append(option);
			});

			const switchPrimeAISizeChartUnits = opt => {
				if (window.switchSC) {
					try {
						switch (opt) {
							case 'cm': switchSC(0); break;
							case 'in': switchSC(1); break;
						}
					} catch (e) {}
				}
			}

			let firstOption = true;
			const optionColumnCookieValue = Cookies.get(`size_guide_option_cols_opt--${handle}`);
			switchPrimeAISizeChartUnits(optionColumnCookieValue);
			options.forEach(opt => {
				if (optionColumnCookieValue) {
					if (opt != optionColumnCookieValue) optionCols.get(opt)?.forEach(col => hideColumn(col));
				} else if (!firstOption) {
					optionCols.get(opt)?.forEach(col => hideColumn(col));
				} else if (firstOption) {
					switchPrimeAISizeChartUnits(opt);
				}
				firstOption = false;
				const header = [...cols.get([...optionCols.get(opt)][0])].filter(cell => cell.nodeName == 'TH')[0];
				let regex = new RegExp(`[^\w\-]${opt}[^\w\-]`);
				// TODO: Negative lookbehind supported since Safari 16.34 - is this acceptable?
				//if (preserve_surroundings) regex = new RegExp(`(?<![\w\-])${opt}(?![\w\-])`);
				header.innerHTML = header.innerHTML.replace(regex, ' <span></span> ');
				const selectorCopy = optionColumnsSelector.cloneNode(true);
				header.querySelector('span')?.replaceChildren(selectorCopy);
				selectorCopy.addEventListener('change', function() {
					const newOpt = this.value;
					optionCols.get(opt).forEach(col => hideColumn(col));
					optionCols.get(newOpt).forEach(col => showColumn(col));
					this.value = opt;
					Cookies.set(`size_guide_option_cols_opt--${handle}`, newOpt, cookie_settings);
					switchPrimeAISizeChartUnits(newOpt);
				});
				selectorCopy.value = opt;
			});
		});
	};
	initSizeGuideTables();

	// Size Guides on product page
	document.querySelectorAll('a[aria-controls=size-guide-modal]').forEach(link => {
		link.addEventListener('click', event => {
			const modal = document.getElementById(link.getAttribute('aria-controls'));
			const container = modal?.querySelector('.Modal__Content');
			const header = modal?.querySelector('.Modal__Header');
			const url = new URL(link.href);
			const handle = url.hash.replace('#size-guide-', '');

			if (!container || !link.href || !handle) {
				event.stopImmediatePropagation();
				return;
			}

			event.preventDefault();

			fetch(url).then(response => {
				if (!response.ok) throw new Error('Bad response');
				return response.text();
			}).then(response => {
				const newPage = new DOMParser().parseFromString(response, 'text/html');
				const tableContainer = container.querySelector('.SizeGuide__TableContainer');
				const contentContainer = container.querySelector('.SizeGuide__ContentContainer');
				while (tableContainer.firstChild) tableContainer.removeChild(tableContainer.firstChild);

				const guide = newPage.querySelector(`[data-size-guide=${handle}]`);
				
				const title = header?.querySelector('.Modal__Title');
				if (title) title.textContent = guide.querySelector('caption').textContent;

				header?.querySelectorAll('.Modal__HeaderContent a').forEach(link => {
					if (link.getAttribute('href') == '#') link.classList.add('primeai_link');
				});
				
				const table = guide.querySelector('table');
				const tableWrapper = document.createElement('div');
				tableWrapper.classList.add('TableWrapper');
				tableWrapper.append(table);
				tableContainer.append(tableWrapper);
				tableContainer.dataset.sizeGuide = handle;
				
				if (guide.dataset.showMeasuringGuide) {
					while (contentContainer.firstChild) contentContainer.removeChild(contentContainer.firstChild);
					newPage.querySelectorAll('.FeatureText').forEach(el => contentContainer.append(el));
				}

				initSizeGuideTables(tableContainer);

				const productFormSizeLabels = new Map();
				table.closest('.Product')?.querySelector('button.ProductForm__AddToCart')?.closest('form')?.querySelectorAll('.SizeSwatch').forEach(label => productFormSizeLabels.set(label.textContent.trim(), label));

				table.querySelectorAll('th:first-child').forEach(cell => {
					const newCell = document.createElement('th');
					newCell.setAttribute('width', '7%');
					cell.after(newCell);
				});

				let hasButtons = false;

				table.querySelectorAll('td:first-child').forEach(cell => {
					const newCell = document.createElement('td');
					cell.after(newCell);
					const value = cell.textContent.trim();
					let option = productFormSizeLabels.get(value);
					if (!option) {
						for (const [key, label] of productFormSizeLabels) {
							if (key.split(' ').includes(value)) {
								option = label;
								break;
							}
						}
					}
					
					if (option) {
						const button = document.createElement('button');
						button.classList.add('Button', 'Button--small');
						button.innerText = guide.dataset.addButtonText || 'Add';

						// Check variant is out of stock
						if (option.closest('.HorizontalList__Item')?.classList.contains('no-stock')) {
							button.classList.add('Button--secondary');
						} else {
							button.classList.add('Button--primary');
						}

						/*
						// Check if variant has tooltip
						if (option.dataset.tooltip) {
							button.dataset.tooltip = option.dataset.tooltip;
						}

						// Check if variant has icon
						const icon = option.querySelector('img.Icon');
						if (icon) {
							button.append("\u00A0");
							button.append(icon.cloneNode());
						}
						*/

						button.addEventListener('click', event => {
							option.click();
							modal.querySelector('.Modal__Close').click();
							setTimeout(() => productFormAddButton.click(), 100);
						});

						newCell.append(button);
						hasButtons = true;
					}
				});

				if (!hasButtons) {
					table.querySelectorAll('tr > :nth-child(2)').forEach(cell => cell.remove());
				}
			}).catch(error => {
				console.error(error);
				window.open(url, '_blank');
			});
		});
	});

	delegate.on('click', '.primeai_link', event => {
		event.preventDefault();
		if (window.OpenWidget) {
			OpenWidget();
			event.target.closest('.Modal')?.querySelector('[data-action=close-modal]')?.click();
		} else {
			alert(event.target.closest('.Modal')?.dataset.messageNoPrimeaiWidget);
		}
	});
	
	delegate.on('click', '.primeai_chart_link', event => {
		event.preventDefault();
		if (window.OpenWidgetSC) {
			OpenWidgetSC();
			event.target.closest('.Modal')?.querySelector('[data-action=close-modal]')?.click();
		} else {
			alert(event.target.closest('.Modal')?.dataset.messageNoPrimeaiChart);
		}
	});



	// cart:refresh - triggers when the cart is refreshed
	// breakpoint:changed - triggers when switching between mobile/tablet/laptop/desktop
	// variant:changed - triggers when changing variant on the product page
	// theme:loading:start - triggers when something starts to load
	// theme:loading:end - triggers when something finishes loading
	// product:added - triggered when product added to cart
	// model:played - triggers when product media play started
	// model:paused - triggers when product media play paused
	// video:played - triggers when product video play started
	// video:paused - triggers when product video play paused
	// scrollspy:target:changed - triggered when there is a change of visibility
	// product:changed - triggered by Shop The Look when a product changes

 		if (Shopify.designMode) {
		document.addEventListener('shopify:section:load', event => {
			event?.target?.querySelectorAll('.HeroCollection__LinkList[data-flickity-options]').forEach(carousel => {
				new Flickity(carousel, JSON.parse(carousel.dataset.flickityOptions || {}));
			});
		});
	}
})();
